import React, { useState } from "react";
import { Table } from "react-bootstrap";

import classNames from "classnames";

import OrderManagementButtons from "./OrderManagementButtons";
import CancelProductModal from "./modals/CancelProduct";
import ChangeProductModal from "./modals/ChangeProduct";

import { ProductDetailsProps } from "../types/order";

import { currencyFormat } from "../../../../../lib/utils";

const ProductDetails = ({
    product: p,
    products,
    order,
    tournaments,
    masterTournaments,
    handleSubmit,
}: ProductDetailsProps): React.ReactNode => {
    const [show, setShow] = useState<Record<string, boolean>>({
        cancelProduct: false,
        changeProduct: false,
    });
    const tournamentName = p?.description.replace(/\s*\d{1,2}[Uu]$/, "").trim();
    const masterTournament = masterTournaments?.find(
        t => t.name === tournamentName,
    );
    const tournament = tournaments?.find(
        t => t.parent === masterTournament?.id && t.ageLevel === p?.name,
    );

    const teamCity = tournament?.schedulingData.teamCities.find(
        team => Object.keys(team)[0] === p.meta.teamId?.toString(),
    );

    const handleClose = (modal: string) =>
        setShow(prev => ({
            ...prev,
            [modal]: false,
        }));

    const handleShow = (modal: string) => {
        setShow(prev => ({
            ...prev,
            [modal]: true,
        }));
    };

    return (
        <>
            <Table
                borderless
                className={classNames({
                    productDetails: true,
                    cancelled: p.status === "cancelled",
                })}
            >
                <thead>
                    <tr>
                        <th colSpan={2}>
                            {p.description}
                            {masterTournament?.designation
                                ? ` - ${masterTournament.designation}`
                                : ""}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {p.status === "cancelled" && (
                        <tr>
                            <td
                                colSpan={2}
                                className={classNames(
                                    "text-decoration-none",
                                    "text-center",
                                )}
                            >
                                <h6 className={classNames("text-danger")}>
                                    Registration Cancelled
                                </h6>
                            </td>
                        </tr>
                    )}
                    <tr>
                        <td>
                            <h5>Cost:</h5>
                        </td>
                        <td>{currencyFormat.format(p.orderPrice)}</td>
                    </tr>
                    <tr>
                        <td>
                            <h5>New or Returning Team:</h5>
                        </td>
                        <td>{p.meta.teamType}</td>
                    </tr>
                    <tr>
                        <td>
                            <h5>Team Name</h5>
                        </td>
                        <td>{p.meta.teamName}</td>
                    </tr>
                    <tr>
                        <td>
                            <h5>Team Id:</h5>
                        </td>
                        <td>{p.meta.teamId}</td>
                    </tr>
                    {p.status !== "cancelled" && (
                        <>
                            <tr>
                                <td>
                                    <h5>Ok to play on Friday?:</h5>
                                </td>
                                <td>
                                    {p?.meta?.teamId &&
                                    tournament?.schedulingData.noFriday.includes(
                                        p.meta.teamId,
                                    )
                                        ? "No"
                                        : "Yes"}
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <h5>Team Hometown:</h5>
                                </td>
                                <td>
                                    {p.meta.teamId &&
                                        teamCity &&
                                        teamCity[p.meta.teamId]}
                                </td>
                            </tr>
                        </>
                    )}
                    <tr>
                        <td colSpan={2}>
                            {p.status !== "cancelled" && (
                                <OrderManagementButtons
                                    handleShow={handleShow}
                                    product={p}
                                />
                            )}
                        </td>
                    </tr>
                </tbody>
            </Table>
            <CancelProductModal
                show={show.cancelProduct}
                handleClose={handleClose}
                handleSubmit={handleSubmit}
                product={p}
                order={order}
            />
            {/* this line is a hack to properly unmount the modal when closed.
            there appears to be a bug related to react-select that prevents the modal
            from properly unmounting leaving the modal's body class, style, and data-attributes
            from being removed
            */}
            {show.changeProduct && (
                <ChangeProductModal
                    handleClose={handleClose}
                    handleSubmit={handleSubmit}
                    masterTournaments={masterTournaments}
                    order={order}
                    product={p}
                    products={products}
                    show={show.changeProduct}
                    tournaments={tournaments}
                />
            )}
        </>
    );
};

export default ProductDetails;
